 <p>La normativa che istituisce il QRSP e ne regolamenta l'aggiornamento è costituita dai seguenti atti:</p>

<div class="example-container mat-elevation-z8">
   <div class="example-table-container">
      <table mat-table [dataSource]="dataSource" class="example-table" matSort matSortActive="data" (matSortChange)="sortData($event)" matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
                Data
              </th>
              <td mat-cell *matCellDef="let element"> {{element.data | date: 'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
                Descrizione
              </th>
              <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
        </ng-container>
        <ng-container matColumnDef="azioni">
            <th mat-header-cell *matHeaderCellDef>
                Azioni
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon class="green" (click)="downloadNormativa(element)"
                matTooltip="Download Normativa">download</mat-icon> </td>
        </ng-container>
       <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
       <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
     </table>
   </div>

   <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"
   [pageIndex]="pageIndex" (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
 </div>
